import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { AppSettings } from "src/config/config";

@Injectable({
  providedIn: "root",
})
export class ViewIdCardService{
      private URL3 = AppSettings.API_ENDPOINT_V3;
    constructor(private http :HttpClient){}

     getDataFromJobId(jobId) {
        const lang = "en";
        const headers = new HttpHeaders()
          .append("Content-Type", "application/json")
          .append("token", localStorage.getItem("usertoken"));
        const url = `${this.URL3}/get/all/id/card/for/particular/job?jobDetailId=${jobId}&lang=en`;
        return this.http.get(url, { headers }).pipe(map((res) => res));
      }

      getStaffDataFromJobId(jobId) {
        const lang = "en";
        const headers = new HttpHeaders()
          .append("Content-Type", "application/json")
          .append("token", localStorage.getItem("usertoken"));
        const url = `${this.URL3}/get/all/id/card/for/particular/job/for/staff?jobDetailId=${jobId}&lang=en`;
        return this.http.get(url, { headers }).pipe(map((res) => res));
      }



       sendIdOnEmail(body) {
        const headers = new HttpHeaders()
          .append("Content-Type", "application/json")
          .append("token", localStorage.getItem("usertoken"));
        const url = `${this.URL3}/email/id/card`;
        return this.http.post(url,body, { headers }).pipe(map((res) => res));
      }

  sendStaffIdOnEmail(body) {
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/email/id/card/for/staff`;
    return this.http.post(url, body, { headers }).pipe(map((res) => res));
  }
}